/** Tipos compartilhados — documentos e alertas (Fase 6). Arquivos ficam fora do banco. */
export const DOCUMENT_KINDS = [
    'CONTRACT',
    'INVOICE',
    'VEHICLE',
    'EMPLOYEE',
    'LICENSE',
    'PERMIT',
    'CERTIFICATE',
    'MACHINE',
    'DATASHEET',
    'BOLETO',
    'PAYMENT_RECEIPT',
    'ENVIRONMENTAL',
    'OTHER',
];
export const DOCUMENT_KIND_LABELS = {
    CONTRACT: 'Contrato',
    INVOICE: 'Nota fiscal',
    VEHICLE: 'Documento de veículo',
    EMPLOYEE: 'Documento de colaborador',
    LICENSE: 'Licença',
    PERMIT: 'Alvará',
    CERTIFICATE: 'Certificado',
    MACHINE: 'Documento de máquina',
    DATASHEET: 'Ficha técnica',
    BOLETO: 'Boleto / guia',
    PAYMENT_RECEIPT: 'Comprovante de pagamento',
    ENVIRONMENTAL: 'Ambiental (MTR / CDF)',
    OTHER: 'Outro',
};
export const DOCUMENT_ENTITY_TYPES = [
    'NONE',
    'CUSTOMER',
    'SUPPLIER',
    'EMPLOYEE',
    'ASSET',
    'PRODUCT',
    'MATERIAL',
    'SALES_ORDER',
    'PURCHASE_ORDER',
    'MAINTENANCE_ORDER',
    'FISCAL_INVOICE',
    'DELIVERY',
    'FINANCIAL_TITLE',
    'WASTE_MANIFEST',
];
export const DOCUMENT_ENTITY_LABELS = {
    NONE: 'Sem vínculo',
    CUSTOMER: 'Cliente',
    SUPPLIER: 'Fornecedor',
    EMPLOYEE: 'Colaborador',
    ASSET: 'Equipamento / veículo',
    PRODUCT: 'Produto',
    MATERIAL: 'Material',
    SALES_ORDER: 'Pedido de venda',
    PURCHASE_ORDER: 'Pedido de compra',
    MAINTENANCE_ORDER: 'Ordem de manutenção',
    FISCAL_INVOICE: 'Nota fiscal',
    DELIVERY: 'Entrega',
    FINANCIAL_TITLE: 'Conta a pagar/receber',
    WASTE_MANIFEST: 'MTR (resíduos)',
};
export const ALERT_KINDS = [
    'DOCUMENT_EXPIRING',
    'VEHICLE_DOC_EXPIRING',
    'MAINTENANCE_PLAN_OVERDUE',
    'MAINTENANCE_ORDER_LATE',
    'PAYABLE_OVERDUE',
    'RECEIVABLE_OVERDUE',
    'DELIVERY_LATE',
    'INVOICE_PENDING_STOCK',
    'EMPLOYEE_ENTRY_PENDING',
];
export const ALERT_KIND_LABELS = {
    DOCUMENT_EXPIRING: 'Documento vencendo',
    VEHICLE_DOC_EXPIRING: 'Seguro / licenciamento',
    MAINTENANCE_PLAN_OVERDUE: 'Preventiva vencida',
    MAINTENANCE_ORDER_LATE: 'Manutenção atrasada',
    PAYABLE_OVERDUE: 'Conta a pagar vencida',
    RECEIVABLE_OVERDUE: 'Conta a receber vencida',
    DELIVERY_LATE: 'Entrega atrasada',
    INVOICE_PENDING_STOCK: 'NF de entrada sem estoque',
    EMPLOYEE_ENTRY_PENDING: 'Lançamento de RH pendente',
};
//# sourceMappingURL=documents.js.map